import { Create, DateTimeInput, minValue, required, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

const initialValues = {
  title: '',
  message: '',
  // image:''
};

const validateDate = [required(), minValue(new Date())];

export const NotificationCreate = (props: unknown) => (
  <Create {...props} title={<CustomTitle />}>
    <SimpleForm redirect={false} defaultValues={initialValues}>
      <TextInput source="title" />
      <TextInput source="message" />
      <DateTimeInput source="deliveryDate" validate={validateDate} defaultValue={new Date()} />
    </SimpleForm>
  </Create>
);
